/* unplugin-vue-components disabled */import script from "./SurfaceHint.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfaceHint.vue?vue&type=script&setup=true&lang=js"

import "./SurfaceHint.vue?vue&type=style&index=0&id=4f409c0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f409c0e"]])

export default __exports__